var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LayoutLeftSvg from './layout-left.icon.svg';
export const LayoutLeftIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LayoutLeftSvg }));
_react_refresh_temp_1 = LayoutLeftIcon;
$RefreshReg$(_react_refresh_temp_1, "LayoutLeftIcon");
